var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ns-stripe-donations-container" },
    [
      _c("div", {
        staticClass: "g-recaptcha",
        attrs: { "data-siteKey": _vm.captchaKey, "data-size": "invisible" }
      }),
      _vm._v(" "),
      _c("form", { staticClass: "stripe-form", attrs: { novalidate: "" } }, [
        _c("div", { staticClass: "form-section" }, [
          _c("h4", { staticClass: "section-title" }, [
            _vm._v(_vm._s(_vm.personalInfoTitle))
          ]),
          _vm._v(" "),
          _c("label", { staticClass: "label", attrs: { for: "first-name" } }, [
            _vm._v(_vm._s(_vm.firstNameLabel))
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.firstName,
                expression: "firstName"
              }
            ],
            staticClass: "input",
            attrs: { id: "first-name", type: "text", required: "" },
            domProps: { value: _vm.firstName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.firstName = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("label", { staticClass: "label", attrs: { for: "last-name" } }, [
            _vm._v(_vm._s(_vm.lastNameLabel))
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.lastName,
                expression: "lastName"
              }
            ],
            staticClass: "input",
            attrs: { id: "last-name", type: "text", required: "" },
            domProps: { value: _vm.lastName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.lastName = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "label",
              class: { "error-label": _vm.showEmailError },
              attrs: { for: "email" }
            },
            [_vm._v(_vm._s(_vm.emailLabel))]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.email,
                expression: "email"
              }
            ],
            ref: "emailRef",
            staticClass: "input",
            class: { "show-errors": _vm.showErrors },
            attrs: { id: "email", type: "email", required: "" },
            domProps: { value: _vm.email },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.email = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _vm.showEmailError
            ? _c("div", { staticClass: "error-helper" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.emailErrorMessage) + "\n      "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "label", attrs: { for: "affiliate-id" } },
            [
              _vm._v(_vm._s(_vm.nuskinIdLabel) + "\n        "),
              _c("span", { staticClass: "optional" }, [
                _vm._v("(" + _vm._s(_vm.optionalLabel) + ")")
              ])
            ]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.affiliateId,
                expression: "affiliateId"
              }
            ],
            staticClass: "input",
            attrs: { id: "affiliate-id", type: "text" },
            domProps: { value: _vm.affiliateId },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.affiliateId = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "separator" }),
        _vm._v(" "),
        _c("div", { staticClass: "form-section" }, [
          _c("h4", { staticClass: "section-title" }, [
            _vm._v(_vm._s(_vm.amountTitle))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "donation-amounts", style: _vm.donationBtnsStyle },
            _vm._l(_vm.buttonAmounts, function(amt) {
              return _c(
                "button",
                {
                  key: amt.value,
                  staticClass: "btn-primary donation-amount",
                  class: [
                    amt.value === _vm.buttonAmount
                      ? "hit-solid"
                      : "primary-outline"
                  ],
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.updateAmount(amt.value)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(amt.displayText) + "\n        "
                  )
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "label",
              class: { "error-label": _vm.showCustomAmountError },
              attrs: { for: "custom-amount" }
            },
            [_vm._v(_vm._s(_vm.amountLabel))]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "input-container",
              class: { "error-input": _vm.showCustomAmountError }
            },
            [
              _c("span", { staticClass: "currency" }, [_vm._v("$")]),
              _vm._v(" "),
              _c(
                "Money",
                _vm._b(
                  {
                    staticClass: "reset-input",
                    attrs: { id: "custom-amount", type: "text" },
                    model: {
                      value: _vm.customAmount,
                      callback: function($$v) {
                        _vm.customAmount = $$v
                      },
                      expression: "customAmount"
                    }
                  },
                  "Money",
                  _vm.money,
                  false
                )
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.showCustomAmountError
            ? _c("div", { staticClass: "error-helper" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.minDonationAmountLabel) + "\n      "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "section-spacer" }),
          _vm._v(" "),
          _c("h4", { staticClass: "section-title" }, [
            _vm._v(_vm._s(_vm.donateTitle))
          ]),
          _vm._v(" "),
          _vm.paymentMethod === "card" && _vm.stripeElementsReady
            ? _c(
                "div",
                [
                  _c(
                    "label",
                    {
                      staticClass: "label",
                      class: { "error-label": _vm.numberInfo.error },
                      attrs: { for: "card-number" }
                    },
                    [_vm._v(_vm._s(_vm.cardNumberLabel))]
                  ),
                  _vm._v(" "),
                  _c("CardNumber", {
                    ref: "cardNumber",
                    staticClass: "stripe-element",
                    class: {
                      focused: _vm.stripeFocusId === "card-number",
                      "error-input": _vm.numberInfo.error
                    },
                    attrs: {
                      id: "card-number",
                      stripe: _vm.stripeKey,
                      options: _vm.stripeOptions
                    },
                    on: {
                      change: function($event) {
                        _vm.numberInfo = $event
                      },
                      focus: function($event) {
                        _vm.stripeFocusId = "card-number"
                      },
                      blur: function($event) {
                        _vm.stripeFocusId = ""
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.numberInfo.error
                    ? _c("div", { staticClass: "error-helper" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.numberInfo.error.message) +
                            "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "expiry-cvc-row" }, [
                    _c(
                      "div",
                      { staticClass: "row-item" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "label",
                            class: { "error-label": _vm.expiryInfo.error },
                            attrs: { for: "card-expiry" }
                          },
                          [_vm._v(_vm._s(_vm.expiryLabel))]
                        ),
                        _vm._v(" "),
                        _c("CardExpiry", {
                          ref: "cardExpiry",
                          staticClass: "stripe-element",
                          class: {
                            focused: _vm.stripeFocusId === "card-expiry",
                            "error-input": _vm.expiryInfo.error
                          },
                          attrs: {
                            id: "card-expiry",
                            stripe: _vm.stripeKey,
                            options: _vm.stripeOptions
                          },
                          on: {
                            change: function($event) {
                              _vm.expiryInfo = $event
                            },
                            focus: function($event) {
                              _vm.stripeFocusId = "card-expiry"
                            },
                            blur: function($event) {
                              _vm.stripeFocusId = ""
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.expiryInfo.error
                          ? _c("div", { staticClass: "error-helper" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.expiryInfo.error.message) +
                                  "\n            "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row-item" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "label",
                            class: { "error-label": _vm.cvcInfo.error },
                            attrs: { for: "card-cvc" }
                          },
                          [_vm._v(_vm._s(_vm.cvcLabel))]
                        ),
                        _vm._v(" "),
                        _c("CardCvc", {
                          ref: "cardCvc",
                          staticClass: "stripe-element",
                          class: {
                            focused: _vm.stripeFocusId === "card-cvc",
                            "error-input": _vm.cvcInfo.error
                          },
                          attrs: {
                            id: "card-cvc",
                            stripe: _vm.stripeKey,
                            options: _vm.stripeOptions
                          },
                          on: {
                            change: function($event) {
                              _vm.cvcInfo = $event
                            },
                            focus: function($event) {
                              _vm.stripeFocusId = "card-cvc"
                            },
                            blur: function($event) {
                              _vm.stripeFocusId = ""
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.cvcInfo.error
                          ? _c("div", { staticClass: "error-helper" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.cvcInfo.error.message) +
                                  "\n            "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-primary hit-solid fluid",
              class: { "button-processing": _vm.loading },
              attrs: { disabled: !_vm.complete, type: "button" },
              on: { click: _vm.pay }
            },
            [
              !_vm.loading && _vm.paymentMethod === "card"
                ? _c("span", [
                    _vm._v(
                      _vm._s(_vm.submitLabel) +
                        _vm._s(
                          _vm.amount
                            ? " $" + _vm.formatMoney(_vm.amount, 2)
                            : ""
                        )
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.loading
                ? _c("span", { staticClass: "loading" }, [
                    _vm._v(_vm._s(_vm.processingText)),
                    _c("span", [_vm._v(".")]),
                    _c("span", [_vm._v(".")]),
                    _c("span", [_vm._v(".")])
                  ])
                : _vm._e()
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("NsToast", {
        ref: "toast",
        attrs: {
          success: !!_vm.processingSuccess,
          error: !!_vm.processingError,
          message: _vm.processingSuccess || _vm.processingError,
          "show-trigger": _vm.toastOpen,
          persistent: ""
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "loader" },
        [
          _c("ns-global-loader-vue", { attrs: { open: _vm.loading } }, [
            _vm.loadingMessage
              ? _c("span", [_vm._v(_vm._s(_vm.loadingMessage))])
              : _vm._e(),
            _vm._v(" "),
            !_vm.loadingMessage
              ? _c("span", { staticClass: "loading" }, [
                  _vm._v(_vm._s(_vm.processingText)),
                  _c("span", [_vm._v(".")]),
                  _c("span", [_vm._v(".")]),
                  _c("span", [_vm._v(".")])
                ])
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }